module.exports = "/_next/static/images/img__fire_left-a65e32be498a4a95174b2932880f763b.png";